import { isHopefullyDomEnvironment } from './IsHopefullyDomEnvironment';

/**
 * In some rare cases, we require the actual current value of a CSS variable such as when setting styles on Google Maps.
 *  In all other cases we should be using the theme values by using the `paletteHelper` from ui-kit or if in js then the theme context from styled-components.
 *
 * @warning This function will only work in a browser environment.
 */
export const getCssVariableValue = (cssVariable: string): string => {
  if (!isHopefullyDomEnvironment()) return '';

  const root = document.documentElement;
  const styles = getComputedStyle(root);
  const property = cssVariable.replace(/^var\(|\)$/g, '');

  return styles.getPropertyValue(property).trim();
};
